// Copyright (c) 2022. Sendanor <info@sendanor.fi>. All rights reserved.

import { FAQ_CLASS_NAME } from "../../../../core/constants/className";
import { map } from "../../../../../../io/hyperify/core/functions/map";
import { ReactNode, useState } from "react";
import "./Faq.scss";

export interface FaqQuestion {
    readonly title       ?: string;
    readonly description ?: string | ReactNode;
}

export interface FaqProps {
    readonly className?: string;
    readonly title?: string;
    readonly description?: string;
    readonly questions?: readonly FaqQuestion[];
    readonly dark ?: boolean;
}

export function Faq (props: FaqProps) {
    const className: string | undefined = props?.className;
    const dark = props?.dark ?? false;
    const title = props?.title;
    const description = props?.description;
    const questions = props?.questions;
    const [selectedTitle, setSelectedTitle] = useState<string>('');
    return (
        <div className={
            `${FAQ_CLASS_NAME}${className ? ' ' + className : ''}`
            + (dark?' '+FAQ_CLASS_NAME+'-dark': '')
        }>
            <div className={`${FAQ_CLASS_NAME}-container`}>
                <div className={`${FAQ_CLASS_NAME}-header`}>
                    <h5 className={`${FAQ_CLASS_NAME}-title`}>{title}</h5>
                    {description ? <p className={`${FAQ_CLASS_NAME}-description`}>{description}</p> : null}
                </div>
                <div className={`${FAQ_CLASS_NAME}-content`}>{
                    map(questions, (item : FaqQuestion) => {
                        const title : string = item.title ?? '';
                        const isSelected = item?.title === selectedTitle;
                        const itemClickHandler = () => {
                            if (isSelected) {
                                setSelectedTitle('');
                            } else {
                                setSelectedTitle(title);
                            }
                        };
                        return (
                            <div
                                key={item.title}
                                className={
                                    `${FAQ_CLASS_NAME}-content-item ${FAQ_CLASS_NAME}-content-item-`
                                    + (isSelected? `selected` : 'unselected')
                                }
                                onClick={itemClickHandler}
                            >
                                <h6 className={`${FAQ_CLASS_NAME}-content-item-title`}>{item.title}
                                    <span className={`${FAQ_CLASS_NAME}-content-item-title-caret`}>{isSelected ? <></> : <>&rsaquo;</>}</span>
                                </h6>
                                {isSelected ? <div className={`${FAQ_CLASS_NAME}-content-item-content`}>{item.description}</div> : null}

                            </div>
                        );
                    })
                }</div>
            </div>
        </div>
    );
}
